import React, { useContext } from 'react';
import { MyDialog } from "../../../component/index";
import DataSourceContext from "../../../context/DataSourceMngContext";
import { Box, CircularProgress } from "@mui/material";

export default function DialogSyncOneDrive() {

  const { dialog } = useContext(DataSourceContext);

  return (
    <MyDialog
      Header={`Syncing...`}
      maxHeight={200}
      open={dialog.loading_sync_onedrive}
      actionContent={false}>
      <Box
        sx={{ position: 'absolute', Top: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={85} />
      </Box>
    </MyDialog>
  );
}